import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { mergeStyleSets, MessageBar, MessageBarType } from '@fluentui/react';
import { Constants } from '@shared/utils/constants';
const contentStyles = mergeStyleSets({
    root: {
        marginBottom: '10px'
    }
});
export const MSuserErrorBanner = ({ context, tenantId })=>{
    return tenantId === Constants.MSTenantId && /*#__PURE__*/ _jsx("div", {
        className: contentStyles.root,
        children: /*#__PURE__*/ _jsx(MessageBar, {
            role: "status",
            messageBarType: MessageBarType.error,
            children: context.loc('MSuser_Banner', 'As a Microsoft Employee, you are not allowed to complete a purchase in AppSource')
        })
    });
};
